module.exports = __webpack_public_path__ + "media/images/home/ic_profile_pic-a8be2680a1175785995dcf88068b0dee.svg";